<template>
    <q-dialog v-model="display">
        <q-card>
            <q-card-section>
                <div class="text-h6">Set Verification action</div>
            </q-card-section>

            <q-card-section class="q-pt-none">
                <p>This ToDo item will be shown to user on their verification tab:</p>
                <q-list dense>
                    <q-item tag="label" v-for="action in actions" :key="action.action">
                        <q-item-section avatar top>
                            <q-radio v-model="selected_action" :val="action.action" color="primary" />
                        </q-item-section>
                        <q-item-section>
                            <q-item-label line="3" v-html="action.label"></q-item-label>
                        </q-item-section>
                    </q-item>

                    <q-item>
                        <q-item-section>
                            <q-field class="q-px-md" borderless>
                                <template v-slot:control>
                                    <q-editor
                                        v-model="action_text"
                                        min-height="5rem"
                                        :toolbar="[
                                            [
                                                {
                                                  label: $q.lang.editor.align,
                                                  icon: $q.iconSet.editor.align,
                                                  fixedLabel: true,
                                                  options: ['left', 'center', 'right', 'justify']
                                                }
                                            ],
                                            ['bold', 'italic', 'strike', 'underline'],
                                            ['hr'],
                                            ['foreColor', 'backColor'],
                                            ['unordered', 'ordered'],
                                            ['removeFormat', 'viewsource'],
                                        ]"
                                        autofocus
                                        @keyup.enter.stop
                                        class="full-width"
                                        v-if="selected_action === 'other'"
                                    />
                                </template>
                            </q-field>
                        </q-item-section>
                    </q-item>
                </q-list>
            </q-card-section>

            <q-card-actions align="right" class="bg-white text-primary">
                <q-btn flat :label="$t('cancel')" color="primary" v-close-popup/>
                <q-btn flat label="Set Verification Action" @click="submit" v-close-popup :disabled="!action_text"/>
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>
<script>

export default {
    name: "SetActionDialog",
    model: {
        prop: 'show',
        event: 'change'
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        userId: {
            type: Number,
            default: 0
        },
        status: {
            type: String,
            default: ''
        }
    },
    computed: {
        display: {
            get: function () {
                return this.show
            },
            set: function (value) {
                this.$emit('change', value)
            }
        },
        toolbar() {
            return [['bold', 'italic', 'underline']]
        },
    },
    data() {
        return {
            variants: ['primary', 'secondary', 'accent', 'dark', 'positive', 'negative', 'info', 'warning'],
            priorities: [
                {label: 'Low', value: 0},
                {label: 'Medium', value: 1},
                {label: 'High', value: 2}
            ],
            foreColor: '',
            backColor: '',
            selected_action: '',
            action_text: '',
            actions: [
                {action: 'action1', label: '<b>Identity Verification</b> - Provide a clear copy of a valid government-issued ID, such as: Passport, National ID card, Driver’s license '},
                {action: 'action2', label: '<b>Address Verification Required</b> - Provide a proof of address (utility bill, bank statement, or rental agreement issued within the last 3 months). Check you email for more details.'},
                {action: 'action3', label: '<b>Transaction Explanation & Supporting Evidence</b> -  Explain the purpose of the transfer and please support supporting documents.'},
                {action: 'action4', label: '<b>Bank Account Verification</b> - Provide a recent bank statement or an official bank document that includes: Your full name (must match your registered name), Your account number, The bank’s name and logo.'},
                {action: 'action5', label: '<b>Source of Funds/Wealth Verification</b> - Provide proof of the source of funds/wealth. Find more details in <a href="https://my.rebitmoney.com/help-and-support/limits/verify-source-funds">Help & Support</a>.'},
                {action: 'other', label: 'Other'},
            ]
        }
    },
    methods: {
        submit() {
            this.$emit('submit', {action: this.action_text, userId: this.userId, status: this.status})
        },
        color (cmd, name) {
            const edit = this.$refs.editor
            edit.caret.restore()
            edit.runCmd(cmd, name, true)
            edit.focus()
        },
    },
    created() {},
    mounted() {},
    watch: {
        selected_action(val) {
            const action = this.actions.find(item => item.action === val)
            this.action_text = (val === 'other') ? '' : action.label
        }
    },
    components: {},
}
</script>
<style>

</style>
